import type { Messages } from '../catalogue.en'

/**
 * The personal notification inbox behind the header bell.
 *
 * The singular carries no `{count}` on purpose: Hebrew says "one notification"
 * with a word, not with a digit, exactly as the Task counts do.
 */
export const notifications: Partial<Messages> = {
  'notifications.trigger': 'התראות',
  'notifications.triggerUnreadOne': 'התראה אחת שלא נקראה',
  'notifications.triggerUnreadMany': '{count} התראות שלא נקראו',
  'notifications.title': 'התראות',
  'notifications.markAllRead': 'סמן הכול כנקרא',
  'notifications.loading': 'טוען התראות',
  'notifications.loadFailed': 'לא ניתן לטעון את ההתראות.',
  'notifications.empty': 'אין במה להתעדכן',
  'notifications.emptyDetail': 'תזכורות משימה שנשלחות אליך בתוך היישום יופיעו כאן.',
  'notifications.unread': 'לא נקראה',
  'notifications.newestShown': 'מוצגות {count} החדשות ביותר',
  'notifications.markReadFailed': 'לא ניתן לסמן את ההתראה כנקראה.',
  'notifications.markAllFailed': 'לא ניתן לסמן את ההתראות כנקראו.',
  'notifications.actionForbidden': 'לחשבון הזה אין הרשאה לסמן התראות כנקראו.',
  'notifications.actionUnavailable': 'ההתראות אינן זמינות. נסה שוב בהמשך.',
  'notifications.rowGone': 'ההתראה הזו אינה עוד בתיבה שלך.',
} as const
